import React, { useState, useReducer, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import breakimage from '../../../../images/auth/Front-break.jpg';
import $ from 'jquery';
import { Row, Col, Tab, Nav, Badge } from "react-bootstrap";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import vehicle from '../../../../images/vehicle/default_machinery.png';
import documents from '../../../../images/doc.png';
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const ViewMachinery = () => {

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const machinery_id = queryParams.get('data');

    const [categoryoption, setCategoryOption] = useState([]);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/machinery_category/get_active`);
                const formattedsource = response.data.map(item => ({
                    value: item.sno,
                    label: item.category_name,
                }));
                setCategoryOption(formattedsource);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    const vehicle_purpose = [
        { value: "1", label: "Production" },
        { value: "2", label: "Utility" },
        { value: "3", label: "Packaging" },
        { value: "4", label: "Others" }
    ];

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const imgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;
    const [data, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    useEffect(() => {
        if (machinery_id) {
            axios.get(`${baseURL}/manage_machinery/${machinery_id}`)
                .then(response => {
                    setData(response.data.data);
                })
                .catch(error => {
                    console.log('There was an error fetching the data!', error);
                });

            fetchData(machinery_id);
        }
    }, [machinery_id]);

    const [maintenanceData, setmaintenanceData] = useState([]);

    const fetchData = (id) => {
        axios.get(`${baseURL}/manage_maintenance/machinery/${machinery_id}`)
            .then(response => {
                setmaintenanceData(response.data.data);
                setHasFetched(true);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };

    const [key, setKey] = useState('basic_info');

    useEffect(() => {
        if (hasFetched) {
            const tables = document.querySelectorAll('.subscription_table');
            tables.forEach((table) => {
                if (!$.fn.dataTable.isDataTable(table)) {
                    $(table).DataTable({
                        "responsive": true,
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            });
        }
    }, [hasFetched]);

    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const [servicetypeoption, setServicetype] = useState([]);
    useEffect(() => {
        const fetchdata = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/servicetype`);
                const formatted = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.servicetype_name,
                }));
                setServicetype(formatted);
            } catch (error) {
                console.log('Error fetching data', error);
            }
        };

        fetchdata();
    }, []);

    const getdervicetype = (values) => {
        const selectedIds = values.split(',').map(id => parseInt(id.trim())); // trim to remove whitespace
        const matchedOptions = servicetypeoption.filter(option => selectedIds.includes(option.value));
        const labels = matchedOptions.map(option => option.label);
        return labels.join(', ');
    };

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>View Machinery</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">Maintanence Management</li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active"><Link to='/manage-vehicles'>Manage Machinery</Link></li>
                    </ol>
                </div>
                <div className='mb-2'>
                    <div className='fs-5 font-w500 text-black'>{data.machinery_name}
                    </div>
                    <div className='d-block'>
                        <label className='fs-7 font-w500 text-black'>{data.brand_name}
                        </label>
                    </div>
                </div>
            </div>

            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs">
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="basic_info">
                                    <i className="fa-regular fa-user me-2" />
                                    <label className="ms-2 fs-6">
                                        Basic Information
                                    </label>

                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="maintance_his">
                                    <i className="fa-solid fa-calendar-days me-2" />
                                    <label className="ms-2 fs-6">
                                        Maintenance  History
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <Tab.Content className="pt-4">
                            <Tab.Pane eventKey="basic_info">
                                <div className="row">
                                    <div className="col-lg-2 d-flex align-items-center justify-content-center mb-2">
                                        <LightGallery
                                            onInit={onInit}
                                            speed={500}
                                            plugins={[lgThumbnail, lgZoom]}
                                        >
                                            <div data-src={(imgBaseUrl && data.machinery_image) ? imgBaseUrl + '/' + data.machinery_image : vehicle} className='rounded px-1 py-0'>
                                                <img src={(imgBaseUrl && data.machinery_image) ? imgBaseUrl + '/' + data.machinery_image : vehicle} alt={data.machinery_name} className='cursor-pointer w-150px h-150px' />
                                            </div>
                                        </LightGallery>
                                    </div>
                                    <div className="col-lg-5 mb-2">
                                        <div className="row mb-2">
                                            <label className="col-5 text-black fs-7">Machinery Category</label>
                                            <label className="col-1 text-black fs-7">:</label>
                                            <label className="col-6 text-black fs-7 font-w500">{data.category_id ? categoryoption.find(itm => itm.value == data.category_id).label : '-'}</label>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-5 text-black fs-7">Machinery Name</label>
                                            <label className="col-1 text-black fs-7">:</label>
                                            <label className="col-6 text-black fs-7 font-w500">{data.machinery_name}</label>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-5 text-black fs-7">Machinery Brand</label>
                                            <label className="col-1 text-black fs-7">:</label>
                                            <label className="col-6 text-black fs-7 font-w500">{data.brand_name}</label>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-5 text-black fs-7">Serial Number</label>
                                            <label className="col-1 text-black fs-7">:</label>
                                            <label className="col-6 text-black fs-7 font-w500">{data.serial_number}</label>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-5 text-black fs-7">Manufactured Date</label>
                                            <label className="col-1 text-black fs-7">:</label>
                                            <label className="col-6 text-black fs-7 font-w500">{data.manufacture_date ? formatDate(data.manufacture_date) : '-'}</label>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-5 text-black fs-7">Purchase Date</label>
                                            <label className="col-1 text-black fs-7">:</label>
                                            <label className="col-6 text-black fs-7 font-w500">{data.purchase_date ? formatDate(data.purchase_date) : '-'}</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-5 mb-2">

                                        <div className="row mb-2">
                                            <label className="col-5 text-black fs-7">Instalation Area</label>
                                            <label className="col-1 text-black fs-7">:</label>
                                            <label className="col-6 text-black fs-7 font-w500">{data.instalation_area ? data.instalation_area : '-'}</label>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-5 text-black fs-7">Machinery Purpose</label>
                                            <label className="col-1 text-black fs-7">:</label>
                                            <label className="col-6 text-black fs-7 font-w500">{data.machinery_purpose ? vehicle_purpose.find(itm => itm.value == data.machinery_purpose).label : '-'}</label>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-5 text-black fs-7">Maintenance Date</label>
                                            <label className="col-1 text-black fs-7">:</label>
                                            <label className="col-6 text-black fs-7 font-w500">{data.upcoming_maintenance ? formatDate(data.upcoming_maintenance) : '-'}</label>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="text-black fs-7">Description</label>
                                            <div className="text-black fs-7 font-w500">
                                                <p>&emsp;&emsp;{data.description ? data.description : '-'}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-lg-6'>
                                        <label className='text-red fs-4 fw-bold mb-3'>Insurance Information</label>
                                        <div className="row mb-2">
                                            <label className="col-5 text-black fs-7">Insurance Company</label>
                                            <label className="col-1 text-black fs-7">:</label>
                                            <label className="col-6 text-black fs-7 font-w500">{data.insurance_company ? data.insurance_company : '-'}</label>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-5 text-black fs-7">Insurance Policy Number</label>
                                            <label className="col-1 text-black fs-7">:</label>
                                            <label className="col-6 text-black fs-7 font-w500">{data.insurance_policy_number ? data.insurance_policy_number : '-'}
                                            </label>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-5 text-black fs-7">Insurance Start Date</label>
                                            <label className="col-1 text-black fs-7">:</label>
                                            <label className="col-6 text-black fs-7 font-w500">{data.insurance_start_date ? formatDate(data.insurance_start_date) : '-'}
                                            </label>
                                        </div>
                                        <div className="row mb-2">
                                            <label className="col-5 text-black fs-7">Insurance End Date</label>
                                            <label className="col-1 text-black fs-7">:</label>
                                            <label className="col-6 text-black fs-7 font-w500">{data.insurance_end_date ? formatDate(data.insurance_end_date) : '-'}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </Tab.Pane>

                            <Tab.Pane eventKey="maintance_his">
                                <Row>
                                    <Col xl={12}>
                                        <div className="table-container">
                                            <table className="subscription_table table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                                <thead>
                                                    <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                        <th className='min-w-80px text-start'>Service Date</th>
                                                        <th className='min-w-100px'>Service Type</th>
                                                        <th className='min-w-100px text-center'>Service Notes</th>
                                                        <th className='min-w-100px text-center'>Description</th>
                                                        <th className='min-w-80px'>Service Amount </th>
                                                        <th className='min-w-80px'>Upcoming Service</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-gray-600 fw-semibold fs-7">
                                                    {maintenanceData.map((data, index) => (
                                                        <tr key={index}>
                                                            <td className='text-start'>
                                                                <label className='text-black font-w400 fs-7'>{formatDate(data.created_at)}</label>
                                                            </td>
                                                            <td>
                                                                <label className='text-black font-w400 fs-7'>{getdervicetype(data.service_type)}</label>
                                                            </td>
                                                            <td>
                                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>{data.service_notes}</span></Tooltip>} >
                                                                    <div className='text-truncate mw-200px text-black font-w400 fs-7'>{data.service_notes}</div>
                                                                </OverlayTrigger>
                                                            </td>
                                                            <td>
                                                                {data.description ? (
                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>{data.description ? data.description : '-'}</span></Tooltip>} >
                                                                        <div className='text-truncate mw-200px text-black font-w400 fs-7'>{data.description ? data.description : '-'}</div>
                                                                    </OverlayTrigger>
                                                                ) : (
                                                                    <div className='text-truncate mw-200px text-black font-w400 fs-7'>{data.description ? data.description : '-'}</div>
                                                                )}
                                                            </td>
                                                            <td align='right'>
                                                                <Badge bg="danger" className='text-white fs-7 py-0 px-1'>
                                                                    <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                                    <span>{data.service_amount}</span>
                                                                </Badge>
                                                            </td>
                                                            <td>
                                                                <label className='text-black font-w400 fs-7'>{formatDate(data.upcomming_maintanence_date)}</label>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </Col>
                                </Row>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </Col>
        </>
    )


}
export default ViewMachinery;